import { Stack, Text, Title } from '@mantine/core';
import { IconHelpCircle } from '@tabler/icons-react';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { DisclosurePopover } from 'src/design/molecules/DisclosurePopover';

export interface IHelpPopoverProps {
  title: string;
  text: string;
}

/** @registry Small help-circle icon that reveals a titled explanatory popover on hover, focus or tap; pairs with page/section headers. */
export const HelpPopover: React.FC<IHelpPopoverProps> = ({ title, text }) => {
  return (
    <DisclosurePopover
      label={`Help: ${title}`}
      width={300}
      position="right"
      content={
        <Stack>
          <Title order={5}>{title}</Title>
          <Text>{text}</Text>
        </Stack>
      }
    >
      <BasicActionIcon variant="subtle" size="md" color="gray">
        <IconHelpCircle />
      </BasicActionIcon>
    </DisclosurePopover>
  );
};
